import { EVENTS } from '@archetype-themes/utils/events'
import { trapFocus, removeTrapFocus } from '@archetype-themes/utils/a11y'

const classes = {
  isAdded: 'is-added'
}

class AddToCart extends HTMLElement {
  constructor() {
    super()
    this.handleCartDrawerChange = this.handleCartDrawerChange.bind(this)
  }

  connectedCallback() {
    // Selezione del quantity-selector e del pulsante all'interno dell'elemento
    this.qtySelector = this.querySelector('quantity-selector')
    this.qtySelectorInput = this.qtySelector?.querySelector('input[name="quantity"]')
    this.button = this.querySelector('.js-add-to-cart')
    this.successMessage = this.querySelector('.js-added')
    this.abortController = new AbortController()
    this.variantId = this.dataset.variantId
    this.activeElement = null
    // Otteniamo il form interno (non il closest form esterno)
    this.form = this.querySelector('form')
    if (!this.button || !this.form) return

    // Intercettiamo il submit per gestirlo in AJAX
    this.form.addEventListener('submit', this.handleSubmit.bind(this), {
      signal: this.abortController.signal
    })

    // Altri listener per interazioni e accessibilità
    this.addEventListener('mouseover', this.open.bind(this), {
      signal: this.abortController.signal
    })

    this.addEventListener('mouseout', this.close.bind(this), {
      signal: this.abortController.signal
    })

    this.button.addEventListener(
      'click',
      () => {
        this.button.getAttribute('aria-expanded') == 'false' ? this.open() : this.close()
      },
      {
        signal: this.abortController.signal
      }
    )

    this.addEventListener(
      'focusout',
      (evt) => (!this.contains(evt.relatedTarget) || !this.contains(evt.target)) && this.close(),
      {
        signal: this.abortController.signal
      }
    )

    this.addEventListener('keydown', (evt) => evt.key === 'Escape' && this.close(), {
      signal: this.abortController.signal
    })

    document.addEventListener(EVENTS.cartDrawerChange, this.handleCartDrawerChange, {
      signal: this.abortController.signal
    })
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  open() {
    if (!this.button) return
    this.button.setAttribute('aria-expanded', 'true')
    this.button.setAttribute('disabled', 'disabled')
    this.classList.remove(classes.isAdded)
    if (this.contains(document.activeElement) && this.qtySelectorInput) {
      this.qtySelectorInput.focus()
    }
  }

  close() {
    if (!this.button) return
    this.button.setAttribute('aria-expanded', 'false')
    this.button.removeAttribute('disabled')
    if (this.activeElement) this.activeElement.focus()
  }

  async handleSubmit(event) {
    event.preventDefault()
    if (this.contains(document.activeElement)) this.activeElement = document.activeElement
    const quantity = this.qtySelectorInput ? parseInt(this.qtySelectorInput.value) : 1
    await this.handleAddToCart(this.variantId, quantity)
  }

  async handleAddToCart(variantId, quantity) {
    const data = {
      id: variantId,
      quantity: quantity,
      sections: ['cart-ajax']
    }
    try {
      console.log('adding products to the cart');
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      if (!response.ok) throw response
      const responseData = await response.json()
      this.handleProductAdded(responseData)
    } catch (error) {
      console.error('Errore nell\'aggiunta al carrello', error)
    }
  }

  handleProductAdded(response) {
    this.dispatchEvent(
      new CustomEvent(EVENTS.ajaxProductAdded, {
        bubbles: true,
        detail: {
          product: response,
          preventCartOpen: true
        }
      })
    )
    // Aggiungiamo la classe tick-mark al pulsante per mostrare "Fatto"
    this.button.classList.add('tick-mark')
    setTimeout(() => {
      this.button.classList.remove('tick-mark')
    }, 1000)

    if (this.activeElement && this.activeElement.classList.contains('js-qty__adjust--plus')) {
      this.classList.add(classes.isAdded)
      trapFocus(this.successMessage)
    }
  }

  handleCartDrawerChange() {
    this.classList.remove(classes.isAdded)
    removeTrapFocus(this.activeElement)
  }
}

customElements.define('at-add-to-cart', AddToCart)
